import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

/** API list endpoints must always yield an array for .find/.map/.filter in UI. */
export function ensureArray(value) {
  if (Array.isArray(value)) return value;
  if (value == null) return [];
  if (typeof value === 'object') {
    if (Array.isArray(value.items)) return value.items;
    if (Array.isArray(value.data)) return value.data;
    if (Array.isArray(value.results)) return value.results;
  }
  return [];
}

/** HTML → plain text for карточек и превью (без тегов). */
export function plainTextFromHtml(html, maxLength) {
  if (!html || typeof html !== "string") return "";
  let text = "";
  if (typeof document !== "undefined") {
    try {
      const doc = new DOMParser().parseFromString(html, "text/html");
      text = (doc.body.textContent || "").replace(/\s+/g, " ").trim();
    } catch {
      text = html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
    }
  } else {
    text = html.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();
  }
  if (maxLength && text.length > maxLength) {
    return `${text.slice(0, maxLength).trim()}…`;
  }
  return text;
}

/** Rich text or plain text → safe HTML for dangerouslySetInnerHTML. */
export function formatRichDescriptionHtml(raw) {
  const text = (raw || '').trim();
  if (!text) return '';
  const hasHtmlTags = /<\/?[a-z][\s\S]*>/i.test(text);
  if (hasHtmlTags) return text;
  return text
    .split('\n')
    .map((line) => line.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'))
    .join('<br/>');
}
